import React from "react";
import "./skeleton.css";

function SkeletonCard() {
  return (
    <div className="kv-card-wrap">
      <div className="sk-block sk-card" />
    </div>
  );
}

export default SkeletonCard;
